export default function getDates(daysAmount) {
      const dayNames = ['יום א', 'יום ב', 'יום ג', 'יום ד', 'יום ה', 'יום ו', 'יום ש'];
      const days = [];
      const now = new Date();
      for (let i = 0; i < daysAmount; i++) {
        const date = new Date(now);
        date.setDate(date.getDate() + i);
        const d = `00${date.getDate()}`.slice(-2);
        const m = `00${date.getMonth() + 1}`.slice(-2);
        const y = `0000${date.getFullYear()}`.slice(-4);
        const dayName = `${d}/${m}/${y} ${dayNames[date.getDay()]}`;
        days.push({
          key: `${i}`,
          date: dayName,
          dateWithoutName: `${d}/${m}/${y}`,
          name: dayNames[date.getDay()]
        });
      }
    const scheduleData = { options: days };
    return scheduleData;
  }